/**
 * Project : workspace
 * File    : AuthContainer.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.auth

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.navigation.NavGraph
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.rememberNavController
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import component.navigation.AlertTopBar
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import navigation.AppNavigator
import navigation.graph.auth.AuthNavGraph
import theme.FriendlyTheme
import theme.ThemeColor

/**
 * Represents the auth container class.
 */

class AuthContainer {
    val viewModel = AuthViewModel()
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun content() {
        val navController = rememberNavController()
        var navGraph : NavGraph = AuthNavGraph().navGraph(navController)
        AppNavigator.shared().authController = navController
        val isAuthVisible = viewModel.isAuthContainerVisible.collectAsState()
        var width = 0.dp
        var height = 0.dp
        if (AppNavigator.shared().screenWidth > 1000.dp) {
            width = 400.dp
            height = 700.dp
        } else {
            width = AppNavigator.shared().screenWidth
            height = AppNavigator.shared().screenHeight
        }
        if (isAuthVisible.value) {
            Dialog(
                onDismissRequest = {
                    CoroutineScope(Job() + Dispatchers.Default).launch {
                        viewModel.hideAuthContainer()
                    }
                },
                properties = DialogProperties(
                    dismissOnBackPress = true,
                    dismissOnClickOutside = true,
                    usePlatformDefaultWidth = false
                ),
            ) {
                Surface(
                    modifier = Modifier
                        .height(height)
                        .width(width)
                        .padding(top = 16.dp),
                    color = ThemeColor.shared().cardBackground,
                    contentColor = ThemeColor.shared().cardBackground,
                ) {
                    FriendlyTheme {
                        Column(
                            modifier = Modifier
                                .height(height)
                                .width(width)
                                .padding(0.dp),
                            horizontalAlignment = Alignment.End
                        ) {
                            AlertTopBar(
                                "", null,
                                onClickClose = {
                                    viewModel.hideAuthContainer()
                                })
                            Scaffold(
                            ){innerPadding ->
                                NavHost(
                                    navController = navController,
                                    graph = navGraph,
                                    modifier = Modifier.padding(innerPadding)
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}